import CarbonSummaryView from "@/routes/apt/[apt_code]/overivew/_components/carbon/carbon-summary-view"
import ResourceTrendView from "@/routes/apt/[apt_code]/overivew/_components/resource-trend/resource-trend-view"
import TopRankView from "@/routes/apt/[apt_code]/overivew/_components/top-rank/top-rank-view"
import KpiMetricView from "./_components/kpi-metric/kpi-metric-view"
import AnomalyView from "./_components/anomaly/anomaly-view"
import { useRef } from "react"
import { useState } from "react"
import { useCallback } from "react"
import { useEffect } from "react"
import { ChevronDown } from "lucide-react"

const OverviewPage = () => {
  const scrollRef = useRef(null)
  const [hasMoreContent, setHasMoreContent] = useState(false)
  const [hasScrolled, setHasScrolled] = useState(false)

  const checkScroll = useCallback(() => {
    const element = scrollRef.current

    if (!element) return

    const hasMore = element.scrollHeight - element.clientHeight - element.scrollTop > 24

    setHasMoreContent(hasMore)

    if (element.scrollTop > 10) {
      setHasScrolled(true)
    }
  }, [])

  useEffect(() => {
    const element = scrollRef.current

    if (!element) return

    checkScroll()

    element.addEventListener("scroll", checkScroll, { passive: true })
    window.addEventListener("resize", checkScroll)

    const observer = new ResizeObserver(checkScroll)
    observer.observe(element)

    // 내부 콘텐츠의 크기 변화도 확인
    if (element.firstElementChild) {
      observer.observe(element.firstElementChild)
    }

    return () => {
      element.removeEventListener("scroll", checkScroll)
      window.removeEventListener("resize", checkScroll)
      observer.disconnect()
    }
  }, [checkScroll])

  const scrollDown = () => {
    const element = scrollRef.current

    if (!element) return

    element.scrollBy({
      top: Math.max(element.clientHeight * 0.65, 200),
      behavior: "smooth"
    })
  }
  return (
    <div className="flex min-w-0 w-full flex-col gap-4 md:h-full scroll-hidden overflow-y-scroll">
      <div
        ref={scrollRef}
        className="
          flex min-h-0 min-w-0 flex-1 flex-col gap-4
          overflow-y-auto overflow-x-hidden
          scroll-hidden
        "
      >
        <KpiMetricView />
        <ResourceTrendView />

        <section className="flex flex-1 flex-col md:flex-row gap-4 md:flex-wrap max-h-120">
          <CarbonSummaryView />
          <div className="md:flex-1">
            <AnomalyView />
          </div>
          <div className="md:flex-1">
            <TopRankView />
          </div>
        </section>

        {hasMoreContent && !hasScrolled && (
          <div
            className="
            left-[calc(50%+90px)] -translate-x-1/2
            pointer-events-none absolute inset-x-0 bottom-0 z-20
            flex justify-center
            pb-3 pt-10
          "
          >
            <button
              type="button"
              onClick={scrollDown}
              aria-label="Scroll down to see more content"
              className="
              pointer-events-auto flex items-center gap-2
              rounded-full border border-slate-200
              bg-white/95 px-4 py-2
              text-xs font-medium text-slate-600
              shadow-md backdrop-blur-sm
              transition hover:bg-white hover:text-slate-900 cursor-pointer
            "
            >
              아래 콘텐츠 보기
              <ChevronDown size={16} className="mt-1 animate-bounce" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default OverviewPage
